import { Form, Grid, Message } from "@arco-design/web-react";
import { useEffect, useRef, useState } from "react";
// import { useStoreValues } from "../../../Components/GlobalContext/GlobalStateProvider";
import {
  allowAlphanumericAndSpecialChars,
  cleanAlphabetsOnly,
  getLocalStorage,
  handleApiError,
  removeLeadingSpace,
  sanitizeEmail,
  sanitizePhoneNumber,
} from "../../../common/Utils/Utils";
import { ManageApis } from "../../../common/APIS/ManageApis";
import InputField from "../../InputField/InputField";
import { useAlert } from "../../../common/Context/AlertContext";
import SubmitButton from "../../submitButton/SubmitButton";
import { SalesQueryFormField } from "./SalesQueryFormField";
import { PCSKey } from "../../../common/productKeys/ProductKeys";
import SalesQueryThankYou from "./SalesQueryThankYou";
import { HARDCODED_PRODUCTKEY } from "../../../common/constant";
const token = getLocalStorage("token");
const Industries = [
  { id: "HEALTHCARE", name: "HealthCare" },
  { id: "FINANCE", name: "Finance" },
  { id: "RETAIL", name: "Retail" },
  { id: "OTHER", name: "Other" },
];

function SalesQueryForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countryCode, setCountryCode] = useState("+91"); // Default country code
  const { showAlert } = useAlert();
  const formRef = useRef();
  const [submitted, setSubmitted] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [form] = Form.useForm();
  const [responseMessage, setResponseMessage] = useState("");
  const [thankYouHeader, setThankYouHeader] = useState("");
  const [trackingInfo, setTrackingInfo] = useState({
    description: "",
    trackingId: "",
  });
  const handleInputChange = (value, field) => {
    const valueWithoutLeadingSpace = removeLeadingSpace(value);
    switch (field) {
      case "name":
        const sanitizedNameValue = cleanAlphabetsOnly(valueWithoutLeadingSpace);
        if (field === "name") {
          // Capitalize first letter of each word
          const capitalizedFirstName = sanitizedNameValue
            .split(' ')
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(' ');
          form.setFieldValue(field, capitalizedFirstName);
        } else {
          form.setFieldValue(field, sanitizedNameValue);
        }
        break;
      case "company":
        const sanitizedCompanyValue = allowAlphanumericAndSpecialChars(
          valueWithoutLeadingSpace
        );
        form.setFieldValue(field, sanitizedCompanyValue);
        break;
      case "industry":
        const selectedValue = value?.value || value;
        setSelectedIndustry(selectedValue);
        form.setFieldValue(field, selectedValue);
        break;
      case "contactDetails":
        // No sanitization needed for number type with country code
        form.setFieldValue(field, valueWithoutLeadingSpace);
        break;
      case "otherIndustry":
        const sanitizedotherIndustryValue = cleanAlphabetsOnly(
          valueWithoutLeadingSpace
        );
        form.setFieldValue(field, sanitizedotherIndustryValue);
        break;
      case "emailId":
        const sanitizedEmailValue = sanitizeEmail(valueWithoutLeadingSpace);
        form.setFieldValue(field, sanitizedEmailValue);
        break;

      default:
        form.setFieldValue(field, valueWithoutLeadingSpace);
        break;
    }
  };

  const handleSubmit = async () => {
    try {
      const isValid = await form.validate();
      if (!isValid) {
        console.log("Validation failed. Please check the form.");
        return;
      }
      const fields = form.getFieldsValue();
      console.log("Fields:", fields);
      const phoneNumber = fields?.contactDetails;
      const phoneNumberAsString = phoneNumber ? String(phoneNumber) : undefined;
      const { contactDetails: _, ...otherFields } = fields;

      let finalFields = { ...otherFields };

      if (finalFields.industry === "Other" && finalFields.otherIndustry) {
        finalFields.industry = finalFields.otherIndustry;
      }

      delete finalFields.otherIndustry;

      const reqBody = {
        ...finalFields,
        productKey: HARDCODED_PRODUCTKEY,
        contactDetails: phoneNumberAsString,
        countryCode: countryCode,
      };
      setIsSubmitting(true);
      const response = await ManageApis(
        "post",
        window.salesEnquiry,
        reqBody,
        token
      );
      const { status_code, message } = response || {};
      const {
        status,
        message: responseMessage = "",
        data,
      } = response?.response_data || {};
      if (status_code === 200 && message === "Success") {
        if (status === "Success") {
          const fullMessage = responseMessage || "";
          const thankYou = "Thank You!";
          const thankYouHeader = fullMessage.includes(thankYou) ? thankYou : "";
          const messageWithoutThankYou = fullMessage
            .replace(thankYou, "")
            .trim();

          setThankYouHeader(thankYouHeader);
          setResponseMessage(messageWithoutThankYou);
          setTrackingInfo({
            description: data.description || "",
            trackingId: data.trackingId || "",
          });

          form.resetFields();
          setSelectedIndustry("");
          setSubmitted(true);
        } else if (status === "Failed") {
          handleApiError(status, responseMessage, status_code, showAlert);
        } else {
          handleApiError(status, message, status_code, showAlert);
        }
      } else {
        handleApiError(status, message, status_code, showAlert);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {!submitted ? (
        <div className="w-100 h-100">
          <div>
            <h3 className="font_30 fw_600">Talk to Sales</h3>
            <p className="font_12 font_500 text_gray10 mb-3">
              Find out how Trial Platform can transform your business
            </p>
          </div>
          <div className=" " style={{}}>
            <div className="customForm">
              <Form
                form={form}
                ref={formRef}
                autoComplete="off"
                onSubmit={handleSubmit}
              >
                <div className="customInput">
                  <Grid.Row gutter={12}>
                    {SalesQueryFormField(
                      form,
                      Industries,
                      selectedIndustry,
                      countryCode
                    ).map((field) => (
                      <InputField
                        inputStyle={{ height: "42px" }}
                        key={field.field}
                        value={form.getFieldValue(field.field)}
                        onChange={(value) =>
                          handleInputChange(value, field.field)
                        } // Use custom onChange handler
                        countryCode={countryCode}
                        onCountryChange={setCountryCode}
                        {...field}
                      />
                    ))}
                  </Grid.Row>
                </div>
                <div className="position-relative d-flex mb-3">
                  <SubmitButton
                    onClick={handleSubmit}
                    isLoading={isSubmitting}
                    className="mt-3 rounded-pill"
                    label="Submit Query"
                  />
                </div>
              </Form>
            </div>
          </div>
        </div>
      ) : (
        <SalesQueryThankYou
          thankYouHeader={thankYouHeader}
          responseMessage={responseMessage}
          trackingInfo={trackingInfo}
          onReset={() => {
            form.resetFields();
            setSelectedIndustry("");
            setSubmitted(false);
            setResponseMessage("");
            setThankYouHeader("");
            setTrackingInfo({ description: "", trackingId: "" });
          }}
        />
      )}
    </>
  );
}

export default SalesQueryForm;
